module.exports = __webpack_public_path__ + "img/add_btn_icon221.70ba74bd.svg";